import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  engagementRouteRef,
  assetExceptionsRouteRef,
  assetRouteRef,
  rootRouteRef,
} from './routes';

const defectDojoDashboardPage = PageBlueprint.make({
  name: 'defectdojo-dashboard',
  params: {
    path: '/defectdojo',
    routeRef: rootRouteRef,
    loader: async () => {
      const { DefectDojoRoutes } = await import(
        './components/DefectDojoRoutes'
      );
      return <DefectDojoRoutes />;
    },
  },
});

export const defectDojoPlugin = createFrontendPlugin({
  pluginId: 'defectdojo',
  routes: {
    root: rootRouteRef,
    engagement: engagementRouteRef,
    asset: assetRouteRef,
    assetExceptions: assetExceptionsRouteRef,
  },
  extensions: [defectDojoDashboardPage],
});
